import styled from 'styled-components';

import { Alert } from 'components/ui';

export const StyledAlert = styled(Alert)`
  padding-top: 4px;
  padding-bottom: 4px;
  margin-top: 5px;
`;
